import { render, staticRenderFns } from "./GroupsList.vue?vue&type=template&id=b86195fe"
import script from "./GroupsList.vue?vue&type=script&lang=ts"
export * from "./GroupsList.vue?vue&type=script&lang=ts"
import style0 from "./GroupsList.vue?vue&type=style&index=0&id=b86195fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports